export const textColor = [
  "#000",
  "#FFF",
  "#B80000",
  "#DB3E00",
  "#FCCB00",
  "#008B02",
  "#006B76",
  "#1273DE",
  "#004DCF",
  "#5300EB",
  "#EB9694",
  "#FAD0C3",
  "#FEF3BD",
  "#C1E1C5",
];

export const photoboothName = "healthywalidiwali";

export const textSize = ["16px", "20px", "24px", "28px", "32px"];

export const textStyle = ["", "Charm", "Great Vibes", "Italianno", "Niconne"];

export const customModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxHeight: "90vh",
    maxWidth: "80vw",
  },
};

export const style = {
  background: "transparent",
  height: "100%",
  border: "dashed 1px",
  position: "relative",
};

export const webCamSettings = {
  id: "my-video",
  className: "capturePic",
  audio: false,
  screenshotFormat: "image/jpeg",
  forceScreenshotSourceSize: "true",
  mirrored: true,
  screenshotQuality: 1,
};

export const cameraSettingsTypeFixer = [
  { id: "default", type: "Default Settings" },
  { id: "manual", type: "Manual Settings" },
];

export const resizeSettings = {
  top: false,
  right: false,
  bottom: false,
  left: false,
  topRight: false,
  bottomRight: true,
  bottomLeft: false,
  topLeft: false,
};

export const cropperFixer = {
  unit: "px",
  x: 0,
  y: 0,
  width: 100,
  height: 100,
};
